import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminSidebar from "./AdminCommon/AdminSidebar";
import AdminHeader from "./AdminCommon/AdminHeader";
import "./Admin.css";
import { Popover, OverlayTrigger, Button } from "react-bootstrap";
import {
    EmailLogsList,

} from "../../redux/Admin/actions/userAction/userAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import FilterComponent from "./AdminCommon/FilterComponent";
import * as constantMessages from "../../constants/constatntMessages";
const regularExpression = /^[0-9a-zA-Z -.(),-,_@/]+$/;
function EmailLogs() {
    const dispatch = useDispatch();

    const actionData = useSelector((state) => state.action);
  

    const [filter, setFilter] = useState(false);
    const emailLogsList = useSelector((state) => state.adminuser) || [];
   

    const totalCount = emailLogsList.totalCount;
   
    const [errors, setErrors] = useState({});
    useEffect(() => {
      
    }, [emailLogsList]);

    const emailData = Array.isArray(emailLogsList?.EmailLogsList)
        ? emailLogsList.EmailLogsList
        : [];
   

    const [searchKey, setSearchKey] = useState("");
    const [searchData, setSearchData] = useState({
        searchKey: "",
        page: 1,
        limit: 10,
        order: -1,
        filterData: {},
    });

    useEffect(() => {
        document.title = "Admin EmailLogs: MinutesVault";
        const payload = {
            page: searchData.page,
            order: searchData.order,
            limit: searchData.limit,
            toDate: searchData.filterData?.toDate,
            fromDate: searchData.filterData?.fromDate,
        };
        if (searchData.searchKey !== "") {
            payload["searchKey"] = searchData.searchKey;
        }
        if (searchData.filterData.page === 1) {
            payload["searchKey"] = searchData.searchKey;
            setSearchData({
                ...searchData,
                page: 1,
            });
            payload.page = 1;
        }
        if (searchData.searchKey.trim()) {
            const errors = {};
            if (!regularExpression.test(searchData.searchKey)) {
                errors.searchKey = constantMessages.titleRegexError;
                setErrors(errors);
            } else {
                setErrors({});
                dispatch(EmailLogsList(payload));
            }
        } else {
            setErrors({});
            dispatch(EmailLogsList(payload));
        }
    }, [
        //  searchData.searchKey,
        searchData.order,
        searchData.page,
        searchData.limit,
        searchData.filterData,

    ]);

    useEffect(() => {
        //alert(6)
        if (searchData.searchKey !== "") {
            //   alert(2)

            const payload = {
                page: 1,
                order: searchData.order,
                limit: searchData.limit,
                toDate: searchData.filterData?.toDate,
                fromDate: searchData.filterData?.fromDate,
            };

            if (searchData.searchKey !== "") {
                payload["searchKey"] = searchData.searchKey;
                setSearchData({
                    ...searchData,
                    page: 1,
                });
                payload.page = 1;
            }
            if (searchData.filterData.page === 1) {
                payload["searchKey"] = searchData.searchKey;
                setSearchData({
                    ...searchData,
                    page: 1,
                });
                payload.page = 1;
            }

            if (searchData.searchKey.trim()) {
                const errors = {};
                if (!regularExpression.test(searchData.searchKey)) {
                    // alert("in error")
                    errors.searchKey = constantMessages.titleRegexError;
                    setErrors(errors);
                } else {
                    setErrors({});
                    dispatch(EmailLogsList(payload));
                }
            } else {
                setErrors({});
                dispatch(EmailLogsList(payload));
            }
        } else {
            // alert(5)
            setSearchData({
                ...searchData,
                page: 1,
            });
        }
    }, [searchData.searchKey]);

    const filterData = (data) => {
        setSearchData((prev) => ({
            ...prev,
            filterData: data,
            page: 1,
        }));
    };

    const handlePageChange = (event, value) => {
        // alert(1);
        setSearchData((prev) => ({
            ...prev,
            page: value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchData((prev) => ({
            ...prev,
            [name]: value,
        }));
        const newPayload = {
            page: 1,
            order: searchData.order,
            limit: searchData.limit,
            toDate: searchData.filterData?.toDate,
            fromDate: searchData.filterData?.fromDate,
        };

        if (value.trim() !== "") {
            newPayload["searchKey"] = value;
        }

        if (value.trim() === "") {
            dispatch(EmailLogsList(newPayload));
        }
    };

    const totalOption =
        totalCount && totalCount % 5 === 0
            ? Math.round(emailLogsList.totalCount / 5)
            : totalCount && totalCount % 5 !== 0
                ? Math.round(totalCount / 5 + 0.5)
                : 0;
    const checkTotalPage =
        totalCount % searchData.limit === 0
            ? Math.round(totalCount / searchData.limit)
            : Math.round(totalCount / searchData.limit + 0.5);
    const totalPage = totalCount ? checkTotalPage : 0;



    const totalPageArray = Array(totalPage).fill();
  
    let modifiedArray = [];
    totalPageArray.map((item, index) => {
        if (
            index === searchData.page - 1 ||
            (index <= searchData.page + 3 && index >= searchData.page)
        ) {
            modifiedArray.push(index);
        }
        return item;
    });
  
    const fromDataCount =
        emailLogsList.length === 0 ? 0 : (searchData.page - 1) * searchData.limit + 1;
    const toDataCount =
        (searchData.page - 1) * searchData.limit + emailData.length;

    useEffect(() => {
     
    }, [searchData.page, searchData.limit]);

    const renderPopover = (message) => (
        <Popover id="popover-message">
            <Popover.Body>{message}</Popover.Body>
        </Popover>
    );
    function stripHtmlTags(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, ""); // Removes all HTML tags
    }
    return (
        <>
            <AdminHeader />
            <AdminSidebar />
            <div className="main-content">
                <div className="meeting-header-text">
                    <h4>Email Logs</h4>
                </div>
                <FilterComponent
                    setfilter={setFilter}
                    filterData={filterData}
                    initData={searchData.filterData}
                    filter={filter}
                />
                <div className="mt-2 table-box responsive-table">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="left-tbl-text">
                            {totalCount > 0 ? (
                                <p>
                                    Showing {fromDataCount} to {toDataCount} of{" "}
                                    {totalCount} entries
                                </p>
                            ) : null}
                        </div>
                        <div className="meeting-f-search">
                            <div className="search-box d-flex align-items-center">
                                <input
                                    type="search"
                                    placeholder="Search By Email Type / Email  To / Subject"
                                    name="searchKey"
                                    onChange={handleChange}
                                    value={searchData.searchKey}
                                    autoComplete="off"
                                />

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#4F2CC8"
                                    className="bi bi-search"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                </svg>
                            </div>
                            <button
                                className="btn rounded-pill add-btn Mom-btn d-flex align-items-center justify-content-center"
                                id="open-form-btn"
                                onClick={(e) => setFilter(true)}
                            >
                                <p>Filter</p>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-funnel filter-svg"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {!emailLogsList.loading &&
                        emailLogsList?.length !== 0 &&
                        emailLogsList.isSuccess ? (
                        <table className="mt-4 table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl.No</th>
                                    <th>Email Type</th>
                                    <th>Email From</th>
                                    <th>Email To</th>
                                    <th>Subject</th>
                                    <th>Body</th>
                                    <th>Status</th>
                                    <th>Attachment</th>
                                    <th>Created At</th>

                                </tr>
                            </thead>

                            <tbody>
                                {emailData.map((item, index) => {
                                  
                                    return (
                                        <tr key={item._id}>
                                            <td data-label="Sl No.">
                                                {(searchData.page - 1) * searchData.limit + index + 1}
                                            </td>
                                            <td data-label="Email Type">{item.emailType}</td>
                                            <td data-label="Email From">
                                                <OverlayTrigger
                                                    trigger={["hover", "focus"]}
                                                    placement="bottom"
                                                    overlay={renderPopover(item.emailFrom)}
                                                >
                                                    <span className="message-preview">
                                                        {(() => {
                                                            const emailMatch = item.emailFrom.match(/<([^>]+)>/);
                                                            const emailOnly = emailMatch ? emailMatch[1] : item.emailFrom;
                                                            return emailOnly.length > 25 ? `${emailOnly.slice(0, 25)}...` : emailOnly;
                                                        })()}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>


                                            {/* <td>{item.emailFrom}</td> */}
                                            <td data-label="Email To">{item.emailTo}</td>
                                            <td>
                                                <OverlayTrigger
                                                    trigger={["hover", "focus"]}
                                                    placement="bottom"
                                                    overlay={renderPopover(item.subject)}
                                                >
                                                    <span className="message-preview">
                                                        {item.subject.length > 25
                                                            ? `${item.subject.slice(0, 25)}...`
                                                            : item.subject}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>
                                            {/* <td>{item.subject}</td> */}


                                            <td data-label="Email Body">
                                                <OverlayTrigger
                                                    trigger={["hover", "focus"]}
                                                    placement="bottom"
                                                    overlay={renderPopover(stripHtmlTags(item.body))}
                                                >
                                                    <span className="message-preview">
                                                        {stripHtmlTags(item.body).length > 25
                                                            ? `${stripHtmlTags(item.body).slice(0, 25)}...`
                                                            : stripHtmlTags(item.body)}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>

                                            <td
                                                data-label="Status"
                                                className="meeting-td-width-5  text-align-center"
                                            >
                                                {item.status}
                                            </td>
                                            <td
                                                data-label="Attachment"
                                                className="text-align-center meeting-td-width-7"
                                            >
                                                {item.attachments || "Not Available"}
                                            </td>
                                            {/* <td>
                                                {item.createdAt.formattedTime}
                                                {item.createdAt.formattedDate}
                                            </td> */}
                                            <td
                                                data-label="Created At Date & Time"
                                                className="meeting-td-width-1"
                                            >
                                                {item?.createdAt.formattedTime}
                                                <p className="detail-date-time"> {item?.createdAt.formattedDate}</p>
                                            </td>


                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : !emailLogsList.loading && (!emailData || emailData.length === 0) ? (
                        <div className="no-data-img">
                            <Alert
                                status={"info"}
                                message={"No data available."}
                                timeoutSeconds={0}
                            />
                            <NoDataFound dataType={"meeting"} />
                            <Button
                                className="mt-2"
                                variant="primary"
                                onClick={(e) => {
                                    setSearchData({
                                        ...searchData,
                                        searchKey: "",
                                        filterData: {},
                                        page: 1,
                                    });
                                }}
                            >
                                Clear
                            </Button>
                        </div>
                    ) : (
                        <div
                            className="meeting-page "
                            style={{ textAlign: "center", paddingTop: 20 }}
                        >
                            <Loader />
                        </div>
                    )}

                    {totalCount <= 1 ? null : (
                        <div className="tbl-bottom">
                            <div className="left-tbl-bottom">
                                {searchData.page !== 1 ? (
                                    <button
                                        className="left-arrow"
                                        onClick={(e) =>
                                            setSearchData({
                                                ...searchData,
                                                page: searchData.page - 1,
                                            })
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="#fff"
                                            className="bi bi-chevron-left"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                                            />
                                        </svg>
                                    </button>
                                ) : null}

                                <Stack spacing={2}>
                                    <Pagination
                                        count={totalPage}
                                        page={searchData.page}
                                        siblingCount={0}
                                        boundaryCount={2}
                                        onChange={handlePageChange}
                                        hidePrevButton
                                        hideNextButton
                                        sx={{
                                            "& .Mui-selected": {
                                                backgroundColor: "#388d27 !important",
                                                color: "#fff !important",
                                            },
                                        }}
                                    />
                                </Stack>
                                {totalPageArray?.length !== searchData.page ? (
                                    <button
                                        className="right-arrow"
                                        onClick={(e) =>
                                            setSearchData({
                                                ...searchData,
                                                page: searchData.page + 1,
                                            })
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="#fff"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                            />
                                        </svg>
                                    </button>
                                ) : null}
                            </div>

                            <div className="right-tbl-bottom">
                                <p>Rows Per Page</p>
                                <select
                                    className="no-opt-box"
                                    name="limit"
                                    onChange={(e) =>
                                        setSearchData({
                                            ...searchData,
                                            page: 1,
                                            limit: e.target.value,
                                        })
                                    }
                                    value={searchData.limit}
                                >
                                    {totalOption &&
                                        Array(totalOption)
                                            .fill()
                                            .map((_, option) => {
                                                return (
                                                    <option value={(option + 1) * 5}>
                                                        {(option + 1) * 5}
                                                    </option>
                                                );
                                            })}
                                </select>
                            </div>
                        </div>
                    )}
                </div>
            </div>


        </>
    )
}



export default EmailLogs